
/**
* Data model that represents an appointment (FlexAppointment)
*
* @class ResourceModel
*/
var ResourceModel = function (data) {
  var self; // Convenience reference so the context of 'this' becomes clearer

  // Predicate this data model on the AbstractDataModel.
  // This establishes core functionality required of DataModels,
  // which can be overwritten by methods below.
  // Specifically, conversion of XML data to JSON
  AbstractDataModel.apply(this, arguments);

  self = this;

  // Observable variables represented by this data model
  self.id = null;
  self.name = null;
  self.locationId = ko.observable(null);
  self.maxApptLeadTime = null;
  self.minApptLeadTime = null;
  self.type = 'single'; // options: single or group

  self.description = '';


	/**
	* Returns the name of the location this resource belongs to
	*
	* @method location
	* @return {String}
	*/
  self.location = ko.computed(function () {
    var loc = qcal.locationsWS.indexedLocations()[self.locationId()];

    return (loc) ? loc.name : '';
  });


	/**
	* SHIM
	*
	* @method appointmentStartTimes
	* @return {Array}
	*/
  self.appointmentStartTimes = ko.computed(function () {
    return [];
  })


	/**
	* Method to convert the XML data representing this DataModel
	* into observed variables above.
	*
	* @method loadData
	* @param {XMLString} data XML String representing this model's data
	* @return {ResourceModel} Returns the data model as chainable, for best practice
	*/
  self.loadData = function (data) {
    var maxLeadMinutes = 0,
      minLeadMinutes = 0;

    // Call the superclass method of the same name
    // This loads the XML into the object's data member
    // and converts the data into JSON for easy assignment
    AbstractDataModel.prototype.loadData.call(self, data);

    // Load JSON to observed variables
    self.id = parseInt(self.json.id, 0) || null;
    self.name = self.json.description;
    self.description = self.json.description;
    self.locationId(parseInt(self.json.locationId, 0) || null);

    self.maxApptLeadTime = {
      description: self.json.type.maxAppointmentLeadTime.text,
      duration: parseInt(self.json.type.maxAppointmentLeadTime.duration),
      minutes: 0,
      units: self.json.type.maxAppointmentLeadTime.units
    };

    self.minApptLeadTime = {
      description: self.json.type.minAppointmentLeadTime.text,
      duration: parseInt(self.json.type.minAppointmentLeadTime.duration),
      minutes: 0,
      units: self.json.type.minAppointmentLeadTime.units
    };

    // Convert the maxAppointmentLeadTime into a standardized unit (minutes)
    maxLeadMinutes = self.maxApptLeadTime.duration;

    switch (self.maxApptLeadTime.units) {
      case 'days':
        maxLeadMinutes = maxLeadMinutes * (24 * 60);
        break;
      case 'hrs':
        maxLeadMinutes = maxLeadMinutes * 60;
        break
    }

    self.maxApptLeadTime.minutes = maxLeadMinutes;

    // Convert the minAppointmentLeadTime into a standardized unit (minutes)
    minLeadMinutes = self.minApptLeadTime.duration;

    switch (self.minApptLeadTime.units) {
      case 'days':
        minLeadMinutes = minLeadMinutes * (24 * 60);
        break;
      case 'hrs':
        minLeadMinutes = minLeadMinutes * 60;
        break
    }

    self.minApptLeadTime.minutes = minLeadMinutes;


    self.appointmentStartTimes = ko.pureComputed(function () {
      var aReturn = [],
        mDate = qcal.cal.today(),
        dt = mDate.date(),
        tz = qcal.timeZoneControl.selectedTZ();

      if (qcal.globalViewType() == 'calendars' && qcal.calendarViewType() == 'day') {

        if (self.id == null || qcal.calendarViewType() != 'day') {
          return [];
        }

        // If there is a timezone, make sure the week date is adjusted to match
        if (tz) {
          // Shift the timezone
          mDate.tz(tz.olson[0]);
          // Reset the hour back to midnight
          mDate.hours(0);
          // The date can get shifted when TZs cross GMT
          // Make sure the date remains the same
          mDate.date(dt);
        }
        // console.log( mDate )

        aReturn = qcal.appointmentsWS.getAppointmentStartTimes(mDate, self.id);
      }

      return aReturn;
    })

    // Return self (ResourceModel) to be chainable, for best practice
    return self;

  };

  // If the model was initialized with a data parameter,
  // call the loadData method to populate the observed variables.
  if (data) {
    self.loadData(data);
  }

  // Return self (loadData) to be chainable, for best practice
  return self;
};

ResourceModel.prototype = AbstractDataModel.prototype;
ResourceModel.prototype.constructor = ResourceModel;
